// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3y5_m","inputDescription":"styles_inputDescription__3HLUT"};